import { useTranslate } from "#src/hooks";
import { useAntTheme } from "hooks/useAntTheme/";
import { Flex, Typography } from "antd";
import { PaletteResponse } from "pages/media/types/";
import { CSSProperties } from "react";
import { SWATCH_SIZE } from "./StyledColorPickerWrapper";

export const BrandkitPresets = ({
  palette,
  onColorClick,
  containerStyle,
  itemStyle,
}: {
  palette: PaletteResponse;
  onColorClick: (color: string) => void;
  containerStyle?: CSSProperties;
  itemStyle?: CSSProperties;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <Flex
      gap={10}
      align="center"
      justify="space-between"
      wrap="wrap"
      style={{ width: "100%", marginBottom: 10, ...containerStyle }}
    >
      {Object.entries(palette).map(
        ([key, color]) =>
          color && (
            <Flex
              key={key}
              gap={6}
              align="center"
              onClick={() => onColorClick(color)}
              style={{ ...itemStyle }}
            >
              <div
                style={{
                  width: SWATCH_SIZE,
                  height: SWATCH_SIZE,
                  backgroundColor: color,
                  borderRadius: 4,
                  border: `1px solid ${theme.colorGrey}`,
                  cursor: "pointer",
                }}
              />
              <Typography.Text style={{ fontSize: 10 }}>
                {t(`media.brandkit.create.${key}.title`)}
              </Typography.Text>
            </Flex>
          )
      )}
    </Flex>
  );
};
